module.exports = __webpack_public_path__ + "img/duoxuan2.f4651666.png";